export const MAX_DURATION_TIME = 8 * 60 * 60;


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/constants/TimerConstants.js